module.exports = __webpack_public_path__ + "static/media/football.14958d03.svg";